import React from 'react';
import { Button } from 'freemium-ui';
import { useTranslation } from 'react-i18next';
import { ConfirmationType, ContactListType } from '../../../shared/types';
import { BulkUpdateType } from '../HeaderComponent/types';

type RemoveFromListButtonProps = {
  selectedRowsLength?: number;
  isAllSelected?: boolean;
  contactList?: ContactListType;
  bulkUpdateSelectedContacts: (data: BulkUpdateType) => void;
  setConfirmationData: (
    str: ConfirmationType | React.SetStateAction<ConfirmationType>,
  ) => void;
};

const RemoveFromListButton = (props: RemoveFromListButtonProps) => {
  const { t } = useTranslation();
  const {
    setConfirmationData,
    selectedRowsLength = 0,
    isAllSelected,
    bulkUpdateSelectedContacts,
    contactList,
  } = props;

  return (
    <>
      <Button
        type="secondary"
        inline
        aria-describedby="contact-lists-dropdown"
        onClick={() =>
          setConfirmationData({
            id: new Date().toISOString(),
            title: `${t('contacts.menu.remove.text')}`,
            confirmButtonText: `${t('contacts.menu.remove.text')}`,
            onConfirm: () => {
              setConfirmationData((old) => ({
                ...old,
                confirmButtonDisabled: true,
              }));
              bulkUpdateSelectedContacts({
                type: 'DELETE',
                fields: {
                  list_ids: [contactList?.display_id],
                },
              });
            },
            className: 'error',
            description: isAllSelected
              ? `${t('contacts.remove_selected_contacts', {
                  contactListName: contactList?.label,
                })}`
              : selectedRowsLength > 1
              ? `${t('contacts.remove_contacts_from_list', {
                  count: selectedRowsLength,
                  name: contactList?.label,
                })}`
              : `${t('contacts.remove_contact_from_list', {
                  count: selectedRowsLength,
                  name: contactList?.label,
                })}`,
            glyph: 'info',
          })
        }
      >
        {t('lists.remove_from_list')}
      </Button>
    </>
  );
};

export default RemoveFromListButton;
